import { Stack } from '@mui/material';
import { BetState } from '../../../../models/games/enums/BetState';
import { AmountText } from '../../../../utils/formatter';
import { Bet } from '../../../report/slice/betRecord';
import { BetRecordDetailCell } from './BetRecordDetailsReport';
import { RoundText } from './details/Details';

type SummaryProps = {
    bet: Bet;
    gameName: string;
    isFailed?: boolean;
};
export const Summary = (props: SummaryProps) => {
    const { bet, gameName, isFailed = false } = props;
    return (
        <>
            <Stack
                direction="row"
                justifyContent="space-between"
                sx={{ fontSize: '0.85rem' }}
            >
                <BetRecordDetailCell
                    first={bet.Time}
                    second={<RoundText bet={bet} gameName={gameName} onGoing />}
                    third={
                        <AmountText
                            amount={
                                (isFailed ? bet.BetAmount : bet.ResultAmount) /
                                100
                            }
                            with_color={false}
                            textAlign={'end'}
                        />
                    }
                    isTitle={false}
                    onGoing={bet.State == BetState.Ready}
                />
            </Stack>
        </>
    );
};
